import {CompetentieCluster} from '../vergelijking/competentieCluster';
import {Dialog} from "../../../types/app-types";

export interface Profiel {
  id?: string;
  correlationId: string;
  naam?: string;
  achternaam?: string;
  geslacht?: string;
  geboortedatum?: string;
  straat?: string;
  straatNummer?: string;
  postcode?: string;
  woonplaats?: string;
  telefoonnummer?: string;
  functies?: ProfielFunctie[];
  opleidingen?: ProfielOpleiding[];
  interesses?: ProfielInteresse[];
  competentieClusters?: CompetentieCluster[];
  uploads?: ProfielUpload[];
  afgerondeTesten?: Dialog[];
  werkvermogens?: IdScoreView[];
  persoonlijkeEigenschappen?: IdScoreView[];
}

export class ProfileMatchView{
  functies?: IdDatumView[];
  opleidingen?: IdDatumView[];
  voorkeuren?: IdScoreView[];
  werkvermogens?: IdScoreView[];
  persoonlijkeEigenschappen?: IdScoreView[];

  constructor(
    profile: Profiel
  ) {
    this.functies = profile.functies && profile.functies.filter(item => item.esId).map(item => ({ esId: item.esId, datum: item.van })) || [];
    this.opleidingen = profile.opleidingen && profile.opleidingen
      .filter(item => item.esId)
      .map(item => ({ esId: item.esId, datum: item.eind })) || [];
    this.voorkeuren = profile.interesses && profile.interesses.map(item => ({ esId: item.esId })) || [];
    this.werkvermogens = profile.werkvermogens || [];
    this.persoonlijkeEigenschappen = profile.persoonlijkeEigenschappen || [];
  }
}

export interface ProfielFunctie {
  id?: number;
  esId?: number;
  naam?: string;
  van?: string;
  tot?: string;
  competentieClusters?: CompetentieCluster[];
  functieFamilies?: string[];
  urenPerWeek?: number;
  deskundigheid?: number;
  bedrijfsnaam?: string;
  uitgevoerdeWerkzaamheden?: string;
  ontwikkeldeCompetenties?: string;
  uploads?: ProfielUpload[];
}

export interface ProfielOpleiding {
  id?: number;
  esId?: number;
  naam?: string;
  eind?: string;
  van?: string;
  naamInstituut?: string;
  doelEnInhoud?: string;
  uploads?: ProfielUpload[];
}

export interface ProfielInteresse {
  id?: number;
  esId?: number;
  naam?: string;
  soort?: string;
  uitsluiten?: boolean;
}

export interface ProfileNewsLetterForm {
  newsletters: boolean;
  partnerNewsletters: boolean;
  inspiratorPanel: boolean;
}

export interface ProfielUpload {
  id: number;
  created?: string;
  naam?: string;
}

export interface MatchTestResult {
  persoonlijkeEigenschappen: IdScoreView[];
  werkvermogens: IdScoreView[];
}

export interface IdScoreView {
  esId: number
  score?: number
}

export interface IdDatumView {
  esId: number,
  datum: string
}
